
import router from '@/router';
import { Component, Vue, Prop } from 'vue-property-decorator';

@Component
export default class CPBuySell extends Vue {

  @Prop({ default: true })
  public hard!: boolean;

  @Prop({ default: true })
  public hasClose!: boolean;

  @Prop({ default: false })
  public hasBack!: boolean;

  public get buySell() {
    return this.$store.state.buySell;
  }

  public search() {
    // @ts-ignore - tell typscript to ignore this line as history is a private api and therefore doesnt appear on the typings
    if (router.history.current.name !== 'Home') {
      router.push('/');
    }
    this.$store.commit('updateFocusElement', 'search');
    this.$store.dispatch('setActiveTab', 'search-results');
    this.close();
  }
  public async goToClientList() {
    // @ts-ignore - tell typscript to ignore this line as history is a private api and therefore doesnt appear on the typings
    if (router.history.current.name !== 'My Account') {
      router.push('/my-account');
    }
    setTimeout(() => {
      const el = document.getElementsByClassName('cp-client-directory')[0];
      this.$store.dispatch('scrollToActiveSection', el);
      this.$store.commit('updateFocusElement', 'cp-client-directory');
    }, 600);
    this.close();
  }

  public close() {
    this.$store.commit('toggleBuySell', false);
  }
}
